import type { PhotosGroupData, ReceptionOrderData } from "@/types/types.d";
import { create } from "zustand";
import { RECEPTION_INITIAL_STATE } from "@/constants/constants";

const initial_store = RECEPTION_INITIAL_STATE as ReceptionOrderData;

interface CaputureStandState {
  receptionData: ReceptionOrderData;
  receptionGroupData: PhotosGroupData[];
  updateReceptionData: (data: ReceptionOrderData) => void;
  updateReceptionGroupData: (data: PhotosGroupData) => void;
  addReceptionGroupData: (data: PhotosGroupData) => void;
  clearReceptionGroupData: () => void;
}

const useReceptionDataStore = create<CaputureStandState>((set, get) => ({
  receptionData: initial_store,
  receptionGroupData: [],
  updateReceptionData: (orderData: ReceptionOrderData) =>
    set({ receptionData: orderData }),
  updateReceptionGroupData: (groupData: PhotosGroupData) => {
    const newGroups = get().receptionGroupData;
    const newGroupsList = newGroups.map((group) => {
      if (group.id !== groupData.id) return group;
      return groupData;
    });

    set({
      receptionGroupData: newGroupsList.filter(
        (groupElement) => groupElement.photos.length > 0,
      ),
    });
  },

  addReceptionGroupData: (gruopData: PhotosGroupData) => {
    const newGroupData = get().receptionGroupData;
    set({ receptionGroupData: [...newGroupData, gruopData] });
  },
  clearReceptionGroupData: () => {
    set({ receptionData: initial_store });
    set({ receptionGroupData: [] });
  },
}));

export default useReceptionDataStore;
